import { useEffect, useState } from "react";
import axios from "axios";
import LoginButton from "./LoginButton";

import config from '../config.json';

const UserStatus = props => {
    const [ status, setStatus ] = useState({});
    const [ loaded, setLoaded ] = useState(false);

    useEffect(() => {
        (async () => {
            try {
                const axiosResponse = await axios({
                    url: `${config.backendUrl}/user`,
                    withCredentials: true,
                    method: "get"
                });

                const data = axiosResponse.data;

                setLoaded(true);
                setStatus({ ...status, loggedIn: true, user: data });
            } catch (exception) {
                setLoaded(true);
                setStatus({ ...status, loggedIn: false });
            }
        })();
    }, []);

    if (!loaded) return (<span>Loading...</span>);

    if (status.loggedIn) {
        const statusStyle = { backgroundColor: "blue", color: "white" };

        return (<span style={statusStyle}>Logged in as {status.user.username}#{status.user.discriminator}.</span>);
    }
    else {
        return (<span>Not logged in. <LoginButton/></span>)
    }
}

export default UserStatus;
